export const COGNITO = {
  REGION: "us-east-1",
  USER_POOL_ID: "us-east-1_K5rFKZHoq",
  APP_CLIENT_ID: "6oboan37mj6rhtkld2gu9j75im",
};